import React, {memo, useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import Api from "../../../utils/api";
import Autocomplete from "@mui/lab/Autocomplete/Autocomplete";
import TextField from "@mui/material/TextField";
import validator from "validator";


const ProductAutoComplete = memo((props) => {


    const { onChange,multiple } = props;

    const [options, setOptions] = useState([]);
    const [typingTimeout, setTypingTimeout] = useState(0);
    const instance = new Api();

    const autoCompleteHandleSelect = (value) => // value is a array that contain all selected element
    {
        if (typeof multiple !== undefined && multiple === true) {
            if (value) {
                onChange(value);
            }
        }
    };

    const autoCompleteHandleChange = (event) =>
    {
        let val = event.target.value;

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        let loop = setTimeout(async () => {
            await new Promise(resolve => {
                resolve(instance.get('/products/autocomplete', {'term': val}).then((response) => {
                    if (typeof response != "undefined") {
                        if (response.length > 0) {
                            setOptions(response);
                        } else {

                            let options = [];
                            setOptions(options);

                        }
                    }
                }));
            })
        }, 750);

        setTypingTimeout(loop);

    };

    return(
        <Autocomplete
            multiple={typeof multiple !== undefined ? multiple : false}
            freeSolo
            onChange={((event, value) => autoCompleteHandleSelect(value))}
            options={options}
            getOptionLabel={option => option.title}
            renderInput={params => (
                <TextField
                    {...params}
                    fullWidth
                    margin={"dense"}
                    label="محصولات"
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={autoCompleteHandleChange}
                />
            )}
        />
    );
});

export default memo(ProductAutoComplete)